module.exports = __webpack_public_path__ + "static/img/home_product_02_zh.3264d66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_product_02_zh.png
// module id = 6YFj
// module chunks = 34